<script>
import { mapActions, mapMutations, mapState } from "vuex";
import "swiper/dist/css/swiper.css";
import ChangePassword from "./components/changePassword.vue";
import {
  getFavouriteSectionEmptyResultsBanner,
  getNoEntriesAvailableBanner
} from "../utils/constants";
import NoResultsBanner from "./noResultsBanner.vue";
import ReservedPropertyCard from "./reservedPropertyCard.vue";
import FavouritePropertyCard from "./favouritePropertyCard.vue";
import {countries} from "../../utils/countries";

export default {
  name: "profileDetailsSection",
  data() {
    return {
      activeNames: ["1"],
      dataValues: "",
      displayPassword: false,
      viewPassword: false,
      user: {},
      total: 0,
      pageCur: 1,
      pageSize: 8,
      formMyInformation: {},
      reservedProperties: [],
      purchasedProperties: [],
      myReservations: {
        gray: true,
        hidePrice: false,
        pageCur: 1,
        pageSize: 8
      },
      subscribed: "",
      firstNameWarn: false,
      lastNameWarn: false,
      addressWarn: false,
      countryCodeWarn: false,
      mobileNumberWarn: false,
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
          loop: true
        },
        on: {
          slideChangeTransitionEnd: function() {
            self.initialSlide = this.activeIndex + 1;
          }
        }
      }
    };
  },
  components: {
    FavouritePropertyCard,
    ReservedPropertyCard,
    NoResultsBanner,
    ChangePassword
  },
  beforeUpdate() {
    document.title = "UNIFI Property: My Account";
  },
  created() {
    var that = this;
    if (
      sessionStorage.getItem("rpage") &&
      sessionStorage.getItem("rpage") !== null &&
      sessionStorage.getItem("rpage") !== undefined
    ) {
      this.myReservations.pageCur = parseInt(sessionStorage.getItem("rpage"));
      sessionStorage.removeItem("rpage");
    }
    that.getReserveLst({
      params: {
        page: that.myReservations.pageCur,
        pageSize: that.myReservations.pageSize
      },
      callback: that.callbackReserveLst
    });
    that.getLst({
      params: {
        page: that.myReservations.pageCur,
        pageSize: that.myReservations.pageSize
      },
      callback: that.callback
    });
    that.getUserDtl({ callback: that.userCallback });
  },
  methods: {
    countries() {
      return countries
    },
    getNoEntriesAvailableBanner,
    getFavouriteSectionEmptyResultsBanner,
    ...mapActions("reserve", {
      getReserveLst: "getLst"
    }),
    ...mapMutations("reserve", {
      setReserveLst: "setLst",
      collectReserve: "collect"
    }),
    ...mapActions("account", [
      "getUserDtl",
      "submitUserInfo",
      "getCosByMon",
      "getSoldList",
      "getCosByYear",
      "getInvoiceNums"
    ]),
    ...mapActions("login", ["signOut", "change"]),
    ...mapActions("book", ["getLst"]),
    ...mapActions("home", ["cancelCollect"]),
    ...mapMutations("book", ["setLst", "collect"]),
    logoutFromAccount() {
      this.logout();
    },

    logout() {
      this.$box.loadings();
      this.signOut({ callback: this.logoutcallback });
    },
    logoutcallback(res) {
      var that = this;
      that.$box.loadings(2);
      if (res.data.code == 0) {
        this.change({ data: "on" });
        localStorage.clear();
        that.$router.replace("/newlogin");
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/newlogin");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/newlogin");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    userCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.user = res.data.data;
        console.log(that.user);
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    handleChange(val) {
      console.log(val);
    },
    callbackReserveLst(res) {
      var that = this;
      if (res.data.code == 0) {
        that.setLst({ data: res.data.data });
        this.reservedProperties = res.data.data;
        console.log("--------------------");
        console.log(this.dataValues);
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        res.data.data.formatList = [];
        res.data.data.list.forEach(v => {
          if (v.housePropertyPOJO.imageUrl) {
            if (v.housePropertyPOJO.imageUrl.indexOf(",") !== -1) {
              v.housePropertyPOJO.imgLst = v.housePropertyPOJO.imageUrl.split(
                ","
              );
            } else {
              v.housePropertyPOJO.imgLst = [v.housePropertyPOJO.imageUrl];
            }
          }
          if (v.houseRoomPojosList.length > 0) {
            res.data.data.formatList.push({
              propertyId: v.housePropertyPOJO.propertyId,
              imgLst: v.housePropertyPOJO.imgLst,
              address: v.housePropertyPOJO.address,
              suburb: v.housePropertyPOJO.suburb,
              price:
                v.houseRoomPojosList[0].revisedPrice !== ""
                  ? that.$box.formatSplit(
                      v.houseRoomPojosList[0].revisedPrice,
                      true
                    )
                  : "",
              rental: that.$box.formatSplit(v.housePropertyPOJO.rental, true),
              maxRental: that.$box.formatSplit(
                v.housePropertyPOJO.maxRental,
                true
              ),
              rentalYield: v.housePropertyPOJO.rentalYield,
              commision: that.$box.formatSplit(
                parseInt(v.housePropertyPOJO.commission),
                true
              ),
              maxCommision:
                v.housePropertyPOJO.maxCommision !== ""
                  ? that.$box.formatSplit(
                      parseInt(v.housePropertyPOJO.maxCommision),
                      true
                    )
                  : "",
              bedsNumber: v.houseRoomPojosList[0].beds
                ? v.houseRoomPojosList[0].beds
                : "",
              favoritesFlag: v.favoritesFlag,
              proertyType: v.housePropertyPOJO.proertyType,
              roomId: v.houseRoomPojosList[0].roomId
                ? v.houseRoomPojosList[0].roomId
                : undefined,
              state: v.housePropertyPOJO.state,
              postcode: v.housePropertyPOJO.postcode,
              apt: v.houseRoomPojosList[0].apt
                ? v.houseRoomPojosList[0].apt
                : "",
              sellFlag: 1,
              orderId: v.ordersId && v.ordersId !== "" ? v.ordersId : null,
              operate: 1,
              clickFlag: true,
              estimatedCompletion: v.housePropertyPOJO.estimatedCompletion,
              estimatedCommenceMent: v.housePropertyPOJO.estimatedCommenceMent,
              landPrice:
                v.housePropertyPOJO.landPrice !== ""
                  ? that.$box.formatSplit(v.housePropertyPOJO.landPrice, true)
                  : "",
              buildPrice:
                v.housePropertyPOJO.buildPrice !== ""
                  ? that.$box.formatSplit(v.housePropertyPOJO.buildPrice, true)
                  : "",
              incentives: v.housePropertyPOJO.incentives,
              ordersId: v.ordersId && v.ordersId !== "" ? v.ordersId : null
            });
          }
        });
        that.setLst({ data: res.data.data });
        this.dataValues = res.data.data;
        console.log("--------------------");
        console.log(this.dataValues);
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    editInfo() {
      var that = this;
      if (
        that.user.firstName.replace(/\s+/g, "") == "" ||
        that.user.lastName.replace(/\s+/g, "") == "" ||
        that.user.address.replace(/\s+/g, "") == "" ||
        that.user.countryCode.replace(/\s+/g, "") == "" ||
        that.user.mobileNumber.replace(/\s+/g, "") == ""
      ) {
        if (that.user.firstName.replace(/\s+/g, "") == "") {
          that.firstNameWarn = true;
        }
        if (that.user.lastName.replace(/\s+/g, "") == "") {
          that.lastNameWarn = true;
        }
        if (that.user.address.replace(/\s+/g, "") == "") {
          that.addressWarn = true;
        }
        if (that.user.countryCode.replace(/\s+/g, "") == "") {
          that.countryCodeWarn = true;
        }
        if (that.user.mobileNumber.replace(/\s+/g, "") == "") {
          that.mobileNumberWarn = true;
        }
        return false;
      }
      that.user.countryCode = that.user.countryCode.replace(/\s+/g, "");
      that.user.mobileNumber = that.user.mobileNumber.replace(/\s+/g, "");
      delete that.user.email;
      that.submitUserInfo({ params: that.user, callback: that.editCallback });
    },
    editCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.getUserDtl({ callback: that.userCallback });
        that.$box.alert(
          "",
          "Your account information updated successfully",
          "success"
        );
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    handleInput(e, type) {
      var that = this;
      if (that.user.firstName.replace(/\s+/g, "") !== "") {
        that.firstNameWarn = false;
      }
      if (that.user.lastName.replace(/\s+/g, "") !== "") {
        that.lastNameWarn = false;
      }
      if (that.user.address.replace(/\s+/g, "") !== "") {
        that.addressWarn = false;
      }
      if (that.user.countryCode.replace(/\s+/g, "") !== "") {
        that.countryCodeWarn = false;
      }
      if (that.user.mobileNumber.replace(/\s+/g, "") !== "") {
        that.mobileNumberWarn = false;
      }
      that.$forceUpdate();
    }
  },
  computed: {
    ...mapState({
      datum: state => state.book.list
    })
  }
};
</script>

<template>
  <el-row style="padding: 10px 0; background-color: #ffffff">
    <el-col :span="24" class="welcome-banner">
      <span class="welcome-text">{{ user.firstName }}, welcome back!</span>
    </el-col>
    <el-col :span="24">
      <el-collapse v-model="activeNames" @change="handleChange">
        <el-collapse-item name="1">
          <template v-slot:title>
            <span class="font-style-collapse" style="padding: 0 10px;"
              >My Information</span
            >
          </template>
          <el-row>
            <el-form
              :hide-required-asterisk="true"
              :label-position="'top'"
              :model="user"
            >
              <el-col :span="24" style="margin-top: 18px;">
                <span class="textFieldsStyle">First Name</span>
                <el-input
                  v-model="user.firstName"
                  :class="{ red: firstNameWarn }"
                  @input="handleInput($event)"
                  placeholder="First Name"
                />
              </el-col>
              <el-col :span="24" style="margin-top: 18px;">
                <span class="textFieldsStyle">Last Name</span>
                <el-input
                  v-model="user.lastName"
                  :class="{ red: lastNameWarn }"
                  @input="handleInput($event)"
                  placeholder="Last Name"
                />
              </el-col>
              <el-col :span="24" style="margin-top: 18px;">
                <span class="textFieldsStyle">Address</span>
                <el-input
                  v-model="user.address"
                  :class="{ red: addressWarn }"
                  @input="handleInput($event)"
                  placeholder="Address"
                />
              </el-col>
              <el-col :span="24" style="margin-top: 18px;">
                <span class="textFieldsStyle">Mobile Number</span>
                <el-row :gutter="20">
                  <el-col :span="8">
                    <el-select
                      v-model="user.countryCode"
                      :class="{ red: countryCodeWarn }"
                      @input="handleInput($event)"
                      placeholder="Country Code"
                      filterable
                    >
                      <el-option
                        v-for="country in countries()"
                        :key="country.code"
                        :label="`${country.code} ${country.dialCode}`"
                        :value="country.dialCode">
                        <span><b>{{ country.name }}</b> <span style="color: #9a9a9a">({{ country.code }})</span> {{ country.dialCode }}</span>
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="16">
                    <el-input
                      v-model="user.mobileNumber"
                      :class="{ red: mobileNumberWarn }"
                      @input="handleInput($event)"
                      placeholder="Mobile Number"
                    />
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="24" style="margin-top: 20px;">
                <span class="subs-heading">Subscriptions</span>
              </el-col>
              <el-col :span="24" style="margin-top: 10px;">
                <el-checkbox class="subs-desc" v-model="user.subscribed"
                  >Subscribe to our email mailing list to hear about new
                  properties and updates from clients
                </el-checkbox>
              </el-col>
              <el-col :span="24" style="margin-top: 10px;">
                <span class="desc-subtext"
                  >To unsubscribe, please tick the relevant box</span
                >
              </el-col>
              <el-col :span="24" style="margin-top: 18px;">
                <!--Password Reset-->
                <change-password />
                <!--End Password Reset-->
              </el-col>
              <el-col
                :span="24"
                style="margin-top: 18px;display: flex;flex-direction: column;"
              >
                <el-button class="ua-secondary-btn" style="" @click="editInfo">
                  Save
                </el-button>
              </el-col>
            </el-form>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="2">
          <template slot="title"
            ><span class="font-style-collapse" style="padding: 0 10px;"
              >My Favourites</span
            >
          </template>
          <el-row
            v-if="
              dataValues.list == null ||
                dataValues.list == '' ||
                dataValues.list == undefined
            "
            style="padding: 10px 0"
          >
            <el-col :span="24">
              <no-results-banner
                :getBannerText="this.getFavouriteSectionEmptyResultsBanner"
              />
            </el-col>
          </el-row>
          <el-row v-else style="padding: 10px 0">
            <el-col
              v-for="(item, index) in dataValues.list"
              :key="index"
              :span="24"
              style="margin: 10px 0;"
            >
              <favourite-property-card :property="item" />
            </el-col>
          </el-row>
        </el-collapse-item>
        <el-collapse-item name="3">
          <template slot="title">
            <span class="font-style-collapse" style="padding: 0 10px;"
              >My Reserved Properties</span
            >
          </template>
          <el-row
            v-if="
              this.reservedProperties.list &&
                this.reservedProperties.list.length <= 0
            "
            style="padding: 10px 0"
          >
            <el-col :span="24">
              <no-results-banner
                :getBannerText="this.getNoEntriesAvailableBanner"
              />
            </el-col>
          </el-row>
          <reserved-property-card
            v-else
            :properties="this.reservedProperties.list"
          />
        </el-collapse-item>
      </el-collapse>
    </el-col>
<!--    <el-col-->
<!--      :span="24"-->
<!--      style="display: flex; flex-direction: column; padding: 0 10px"-->
<!--    >-->
<!--      <el-button @click="logoutFromAccount" class="ua-secondary-btn">-->
<!--        Log Out-->
<!--      </el-button>-->
<!--    </el-col>-->
  </el-row>
</template>

<style scoped>
.welcome-text {
  color: #ffffff;
  font-family: DINosaur-a, sans-serif;
  font-size: 30px;
  font-weight: 500;
  padding: 5px 10px;
}

.ua-secondary-btn {
  color: #ffffff;
  font-family: DINosaur-a, sans-serif;
  font-size: 20px;
  font-weight: 500;
  display: flex;
  padding: 10px 0;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 20px;
  border: 2px solid #003333;
  background: #003333;
}

.el-collapse-item /deep/ .el-collapse-item__header {
  background-color: #ffffff;
}

.el-collapse-item /deep/ .el-collapse-item__wrap {
  background-color: #ffffff;
  padding: 0 10px;
}

.el-collapse-item /deep/ .el-collapse-item__content {
  color: #ffffff;
}

.font-style-collapse {
  font-family: DINosaur-a, sans-serif;
  font-size: 26px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.el-card /deep/ .el-card__header {
  padding: 0 !important;
  border-bottom: none;
}

.textFieldsStyle {
  color: #003333;
}

.subs-heading {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.subs-desc {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
  white-space: normal;
  word-wrap: break-word;
  width: 100%;
  display: flex;
  align-items: center;
}

.desc-subtext {
  color: #003333;
  font-family: DINosaur-a, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 125%;
}

.icon-hide {
  padding-top: 2px;
  filter: invert(64%) sepia(13%) saturate(131%) hue-rotate(182deg)
    brightness(90%) contrast(87%);
  height: 14px;
}

.el-checkbox {
  .el-checkbox__label {
    font-size: 14px;
    color: #003333;
  }
}

.red {
  border: 1px solid #ff4e4e;
}

.welcome-banner {
  background-color: #003333;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  padding: 5px 0;
}

.el-checkbox {
  .el-checkbox__inner {
    border-color: #003333;
  }

  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #003333;
    border-color: #003333;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/profile/profileDetailsSection.vue